import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    returnPages: [
      { from: 'ChildCard', to: 'ChildrenList' },
      { from: 'PaymentCard', to: 'PaymentsList' }
    ]
  },
  getters: {
    getReturnPages: (state) => state.returnPages
  },
  mutations: {
    updateReturnPages(state, payload) {
      const index = state.returnPages.findIndex((page) => page.from === payload.from)
      if (index !== -1) {
        Vue.set(state.returnPages, index, { ...payload })
      } else {
        state.returnPages.push(payload)
      }
    }
  }
}
